<template>
  <el-dialog
    :visible.sync="isBatchSupplyShow"
    width="30%"
  >
    <span slot='title'>{{orderNumberList.length <= 1 ? $t('after-sales::after-sale-list::detail_refund_confirm_tips') : $t('after-sales::after-sale-list::detail_refund_apply_tips') }}</span>
    <span>{{ $t('after-sales::after-sale-list::detail_sales_order_num') }}:</span>
    <span v-for="(item, index) in orderNumberList" :key="index" style="margin-bottom:20px;">
      {{ item }}
      <span v-if="index < orderNumberList.length - 1">、</span>
    </span>
    <p>{{ $t('after-sales::after-sale-list::detail_warning_tips') }}!</p>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close">{{ $t('after-sales::after-sale-list::detail_btn_cancel') }}</el-button>
      <el-button type="primary" @click="submitConfirm">{{ $t('after-sales::after-sale-list::detail_btn_confirm') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getRefundOrder } from '@/server/after-sales'

export default {
  name: 'batchSupplyModal',
  props: {
    batchSupplyData: Array,
    isBatch: Boolean
  },
  data() {
    return {
      isBatchSupplyShow: false
    }
  },
  methods: {
    show() {
      this.isBatchSupplyShow = true
    },
    close() {
      this.isBatchSupplyShow = false
      if (!this.isBatch) {
        this.$emit('clearData')
      }
    },
    async submitConfirm() {
      if (this.batchSupplyData.length <= 0) {
        this.$message.error('请选择订单')
        return
      }
      var obj = {
        ids: this.batchSupplyData.map(item => {
          return item.id
        }),
        status: 2
      }
      const { data } = await getRefundOrder(obj)
      if (data.code === 0) {
        this.$message.success('售后订单申请成功!')
        this.isBatchSupplyShow = false
        this.$emit('getList')
        this.$emit('clearData')
      }
    }
  },
  computed: {
    orderNumberList() {
      var array = this.batchSupplyData.map(item => {
        return item.refundNo
      })
      return array
    }
  }
}
</script>

<style lang="scss" scoped></style>
